import eventListeners from './event-listeners';
import documentCopyHandler from '../handlers/document-copy-handler';

const copyListener = (element) => {
  eventListeners.add(element, 'copy', documentCopyHandler);
};

export default copyListener;
